import { render, staticRenderFns } from "./AppShellContainer.vue?vue&type=template&id=3ebb222e&"
import script from "./AppShellContainer.vue?vue&type=script&lang=js&"
export * from "./AppShellContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports